var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningPathSpiral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 533,
    viewBox: "0 0 373 533",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.22236 2.58107C2.22236 2.58107 64.1725 16.1042 69.6826 52.6596C73.1041 75.3591 75.9394 97.9495 57.1875 113.106C45.719 122.376 32.2853 127.742 25.2055 116.928C18.2504 106.305 24.688 92.8929 33.383 80.7035C62.1438 40.3836 115.376 81.1955 138.162 108.168C175.423 152.276 102.498 268.271 166.219 309.82C194.986 328.578 249.18 317.85 262.965 278.19C267.119 266.24 268.437 258.505 260.706 251.491C251.937 243.535 241.149 250.812 231.331 261.061C204.163 289.419 224.571 333.893 249.557 354.946C294.567 392.868 366.133 335.642 397.996 387.08C426.334 432.826 390.463 530.976 390.463 530.976",
    stroke: "#EEEEEE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningPathSpiral);
export default __webpack_public_path__ + "static/media/learningPathSpiral.c630fe946932bb92b28375c3e2dd3115.svg";
export { ForwardRef as ReactComponent };